/** @jsx jsx */
import { jsx, Box } from 'theme-ui'

const Section = (props) => {
    return (
        <Box as="section" {...props} />
    )
}

Section.defaultProps = {
    py: [4, 5]
}

Section.displayName = 'Section'

export default Section
